import * as React from "react"
import * as styles from './footer.module.scss';
import { Link } from "gatsby"
import { useSiteMetadata } from "../../hooks/use-site-metadata"
import { StaticImage } from "gatsby-plugin-image";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRightLong } from '@fortawesome/free-solid-svg-icons'
import { faInstagram, faSquareFacebook } from '@fortawesome/free-brands-svg-icons';
import Logo from "../logo";

const Footer = (props) => {

  const { email: email, donationURL, title: siteTitle, facebook: facebook, instagram: instagram } = useSiteMetadata();

  return (
    <React.Fragment>
      <a href={donationURL} className={`button primary ${styles.donateButton}`}>Donate <FontAwesomeIcon icon={faArrowRightLong} size="xs" /></a>
      <section className={`clear-fix ${styles.footerCTA}`}>
        <StaticImage src="../../images/footer-hero.jpg" alt="" placeholder="blurred" loading="lazy" layout="fullWidth" className={styles.footerCTABackground} />
        <div className={styles.footerCTAContent}>

          <h2>Stand with Sergio – Take Action Today!</h2>

          <p>Sergio Farias has spent his life working for his community, and now he’s ready to fight for you in Sacramento. With your support, we can build a stronger, more affordable California for all. <strong>Join the movement and help make a difference!</strong></p>

          <a href={donationURL} className="button primary">Donate <FontAwesomeIcon icon={faArrowRightLong} size="xs" /></a>

        </div>
        {/* <div className={styles.footerCTAbannerOverlay} /> */}
      </section>
      <footer className={styles.siteFooter}>
        <div className="container small">
          {/* <Link to="/" style={{display: 'inline-block'}}>
            <Logo className={styles.siteLogo} />
          </Link>
          <br />
          <p className={styles.contactInfo}>
            <a href={`mailto:${email}`}>{email}</a>
          </p> */}



              <Link to="/" style={{display: 'inline-block'}}>
                <Logo className={styles.siteLogo} />
              </Link>


              <p className={styles.contactInfo}>
                <a href={`mailto:${email}`}>{email}</a>
                <br />
                <a href={instagram} target="_blank" rel="noreferrer" title="Instagram"><FontAwesomeIcon icon={faInstagram} size="xl" title="Instagram" /></a>
                {/* &nbsp;&nbsp;&nbsp;
                <a href={facebook} target="_blank" rel="noreferrer" title="Facebook"><FontAwesomeIcon icon={faSquareFacebook} size="xl" title="Facebook" /></a> */}
              </p>

              <p className={styles.paidFor}>
              Paid for by Sergio Faria for Assembly 2026
              </p>

        </div>
      </footer>
    </React.Fragment>
  )
}

export default Footer